import ServiceTemplate from '../ServiceTemplate';

const CreditAdvice = () => {
  const serviceData = {
    title: 'ייעוץ אשראי',
    description: 'ייעוץ מקצועי לשיפור דירוג האשראי שלכם והתאמת פתרונות אשראי מיטביים, תוך התמקדות בבניית תכנית אישית לשיפור המצב הפיננסי.',
    sections: [
      {
        title: 'למה חשוב ייעוץ אשראי?',
        content: 'דירוג אשראי טוב הוא מפתח לקבלת הלוואות בתנאים טובים ולהתנהלות פיננסית בריאה. ייעוץ אשראי מקצועי יכול לעזור לכם להבין את המצב הנוכחי, לזהות נקודות לשיפור, ולבנות תכנית פעולה שתוביל לשיפור הדירוג ולתנאי אשראי טובים יותר.'
      },
      {
        title: 'איך התהליך עובד?',
        content: 'נתחיל בניתוח מקיף של מצב האשראי שלכם, כולל בדיקת דוחות אשראי, זיהוי גורמים שמשפיעים לרעה על הדירוג, ובחינת ההתחייבויות הקיימות. נבנה תכנית פעולה מפורטת לשיפור הדירוג, נלווה אתכם ביישום התכנית, ונסייע במציאת פתרונות אשראי מתאימים לצרכים שלכם.'
      }
    ],
    benefits: [
      'שיפור דירוג האשראי',
      'תנאי הלוואות טובים יותר',
      'ייעוץ מקצועי ואובייקטיבי',
      'תכנית פעולה מותאמת אישית',
      'ליווי בתהליך מול הבנקים',
      'פתרונות אשראי חכמים'
    ],
    faqs: [
      {
        question: 'כמה זמן לוקח לשפר דירוג אשראי?',
        answer: 'שיפור דירוג אשראי הוא תהליך שלוקח זמן, בדרך כלל בין 6 ל-12 חודשים, תלוי במצב ההתחלתי ובמידת השיפור הנדרשת. עם זאת, שינויים חיוביים ראשונים יכולים להיראות כבר אחרי 2-3 חודשים של התנהלות נכונה.'
      },
      {
        question: 'מה משפיע על דירוג האשראי?',
        answer: 'דירוג האשראי מושפע ממספר גורמים: היסטוריית תשלומים, היקף ההתחייבויות הקיימות, אחוז ניצול מסגרות האשראי, ותק חשבונות הבנק, בקשות אשראי חדשות, ועוד. נעזור לכם להבין את כל הגורמים ואיך לשפר כל אחד מהם.'
      },
      {
        question: 'האם אפשר לקבל הלוואה עם דירוג אשראי נמוך?',
        answer: 'כן, אבל התנאים עלולים להיות פחות טובים. אנחנו נעזור לכם למצוא את האפשרויות הטובות ביותר הזמינות במצבכם הנוכחי, ובמקביל נעבוד על שיפור הדירוג כדי שתוכלו ליהנות מתנאים טובים יותר בעתיד.'
      },
      {
        question: 'איך מונעים פגיעה בדירוג האשראי?',
        answer: 'המפתח הוא התנהלות פיננסית אחראית: תשלום חשבונות בזמן, שמירה על יחס סביר בין הכנסות להוצאות, הימנעות מניצול יתר של מסגרות אשראי, ובדיקה תקופתית של דוחות האשראי. נלמד אתכם את כל הכללים לשמירה על דירוג אשראי טוב.'
      },
      {
        question: 'האם כדאי לאחד הלוואות לשיפור דירוג האשראי?',
        answer: 'איחוד הלוואות יכול להיות פתרון טוב במקרים מסוימים, כי הוא מפשט את ההתנהלות ולעתים מקטין את ההחזר החודשי. נבחן את המצב שלכם ונמליץ אם איחוד הלוואות הוא צעד נכון עבורכם, תוך התחשבות בכל ההיבטים הפיננסיים.'
      }
    ],
    whatsappMessage: 'שלום, אני מתעניין/ת בייעוץ אשראי ואשמח לקבל מידע נוסף.'
  };

  return <ServiceTemplate {...serviceData} />;
};

export default CreditAdvice; 